import React from 'react';

const CopyRight = () => {
    return (
        <>
            <div className='bg-dark contact-message text-center'>
                <p className='mb-0 py-3 fw-lighter text-white'>&copy; 2025 The Holiday Basket. All Rights Reserved.</p>
            </div>
        </>
    )
}

export default CopyRight;